import { render, staticRenderFns } from "./ProductItemLinkIndex.vue?vue&type=template&id=5bd39e2f&"
import script from "./ProductItemLinkIndex.vue?vue&type=script&lang=js&"
export * from "./ProductItemLinkIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports